export const configurationStyles = theme => ({
  button: {
    margin: theme.spacing(),
  }
})